import { FalhaServico } from './../../../models/falha-servico';
import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Historico } from 'src/app/models/historicoSolicitacoes/historico-solicitacao.model';
import { DeclaracaoCompletaService } from './declaracao-completa.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-declaracao-completa',
  templateUrl: './declaracao-completa.component.html',
  styleUrls: ['./declaracao-completa.component.scss'],
})
export class DeclaracaoCompletaComponent implements OnInit {
  public downloadURL: any;
  public falhaServico = new FalhaServico();

  @Input() histDeclaracaoComp = new Array<Historico>();
  @ViewChild('modalErro') modalErro: ElementRef;

  constructor(
    private declaracaoCompletaService: DeclaracaoCompletaService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {}

  capturaErro(retornoErro: any) {
    this.falhaServico = retornoErro.error[0];
    this.falhaServico.message = retornoErro.message;
  }

  baixarPdf(orderId: string) {
    const obj = {
      orderId: orderId,
      origin: 22,
      middle: 36,
    };

    this.declaracaoCompletaService.baixarPdf(obj).subscribe(
      (res) => {
        this.downloadURL = window.URL.createObjectURL(res);
        window.open(this.downloadURL);
      },
      (err) => {
        this.capturaErro(err);
        this.open(this.modalErro);
      }
    );
  }

  open(content) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
    });
  }
}
